import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

export const MerchantSettlementPath = "/merchant-settlement-report";

export const merchantAddPath = urlJoin(MerchantSettlementPath, "add");
export const merchantAddUrl = merchantAddPath;

export enum MerchantSettlementUrlFiltersEnum {
  payoutId = "payoutId",
  settlementDateFrom = "settlementDateFrom",
  settlementDateTo = "settlementDateTo"
}

export enum MerchantSettlementUrlFiltersWithMultipleValues {
  brand = "brand",
  mall = "mall"
}

export type MerchantSettlementListUrlDialog =
  | "download"
  | "remove"
  | TabActionDialog;

export type MerchantSettlementListUrlFilters = Filters<
  MerchantSettlementUrlFiltersEnum
> &
  FiltersWithMultipleValues<MerchantSettlementUrlFiltersWithMultipleValues>;

export type MerchantSettlementListUrlQueryParams = ActiveTab &
  MerchantSettlementListUrlFilters &
  BulkAction &
  Dialog<MerchantSettlementListUrlDialog> &
  Pagination &
  SingleAction;

export const MerchantSettlementListUrl = (
  params?: MerchantSettlementListUrlQueryParams
) => MerchantSettlementPath + "?" + stringifyQs(params);
